<template>
  <div class="vehicles">
    <SectionHeader :title="$t('vehicles.vehicles')">
      <template v-slot:meta>
        <Link :to="`/company/vehicles/new`" class="button button-green button-round button-small">{{
          $t('vehicles.addVehicle')
        }}</Link>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <template v-else>
          <div v-if="vehicles.length == 0">
            <p>{{ $t('vehicles.noVehicles') }}.</p>
          </div>
          <template v-else>
            <LinkList>
              <LinkListItem
                v-for="vehicle in vehicles"
                :key="vehicle.uuid"
                :primaryLink="`/company/vehicles/${vehicle.uuid}`"
              >
                <template #main-content>
                  <span>{{ vehicle.name }}</span>
                  <span>
                    {{ vehicle.chambers.length }}
                    <span v-if="vehicle.chambers.length == 1">{{ $t('meta.chamber') }}</span
                    ><span v-else>{{ $t('meta.chambers') }}</span>
                  </span>
                </template>
                <template #action-content>
                  <Link :to="`/company/vehicles/${vehicle.uuid}`" class="link-list-item__action"
                    ><span class="material-icons">edit</span></Link
                  >
                  <button
                    @click.prevent="deleteVehicle(vehicle.uuid)"
                    :disabled="!vehicle.can_be_deleted"
                    :title="deleteButtonText(vehicle)"
                    class="link-list-item__action"
                  >
                    <span class="material-icons">delete</span>
                  </button>
                </template>
              </LinkListItem>
            </LinkList>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import LinkListItem from '@/components/LinkList/LinkListItem.vue'
import LinkList from '@/components/LinkList/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import vehiclesApi from '@/api/vehicles'

export default {
  name: 'company_vehicles',
  inject: ['companyUser', 'showPopup'],
  data() {
    return {
      loading: true,
      vehicles: [],
    }
  },
  components: {
    CompanyNav,
    LinkList,
    LinkListItem,
    LoadingSpinner,
    SectionHeader,
  },
  methods: {
    async getVehicles() {
      this.loading = true
      this.vehicles = await vehiclesApi.getAllForCompany(this.companyUser.company_uuid)
      this.loading = false
    },
    async deleteVehicle(vehicleUuid) {
      const confirmAlert = await this.showPopup({
        content: this.$t('vehicles.vehicleDeleteConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return null

      const result = await vehiclesApi.delete(vehicleUuid)
      if (result.success) {
        this.getVehicles()
      }
    },
    deleteButtonText(vehicle) {
      if (!vehicle.can_be_deleted) {
        return this.$t('vehicles.cannotBeDeleted')
      }
    },
  },
  async mounted() {
    this.getVehicles()
  },
}
</script>
